import { CssBaseline } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Suspense, lazy, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import NotificationBanner from "./components/NotificationBanner";
import BookDemoPage from "./pages/BookaDemo";
import ScrollToTop from "./components/ScrollToTop";
import ComingSoon from "./pages/ComingSoon";
import AdminPage from "./pages/Admin";
import LoginPage from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import DigitalGembaWalk from "./pages/DigitalGembaWalk";

// Lazy loading pages (code splitting)

const HomePage = lazy(() => import("./pages/HomePage"));
const SolutionsPage = lazy(() => import("./pages/SolutionsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const Pricing = lazy(() => import("./pages/Pricing"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const EmachinePage = lazy(() => import("./pages/products/Emachine"));

function Loading() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
      }}
    >
      <CircularProgress />
    </Box>
  );
}

function App() {
  const [notification, setNotification] = useState<string | null>(
    "🚀 New feature released!",
  );
  console.log("notification", notification);
  const bannerVisible = false; //Boolean(notification);
  return (
    <HelmetProvider>
      <Router>
        <CssBaseline />
        <NotificationBanner
          message={notification}
          onClose={() => setNotification(null)}
        />
        <Navbar bannerVisible={bannerVisible} />
        <Suspense fallback={<Loading />}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/products/emachine" element={<EmachinePage />} />
            <Route path="/products/flowlink" element={<ComingSoon />} />

            <Route path="/products/gemba" element={<DigitalGembaWalk />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/book-demo" element={<BookDemoPage />} />

            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
